import {
    FETCH_AGENT_PROGRESSION_REQUEST,
    FETCH_AGENT_PROGRESSION_SUCCESS,
    FETCH_AGENT_PROGRESSION_FAILURE,
    
    FETCH_PROGRESSION_CONFIGURATIONS_REQUEST,
    FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS,
    FETCH_PROGRESSION_CONFIGURATIONS_FAILURE,

    CREATE_PROGRESSION_CONFIGURATION_REQUEST,
    CREATE_PROGRESSION_CONFIGURATION_SUCCESS,
    CREATE_PROGRESSION_CONFIGURATION_FAILURE,

    UPDATE_PROGRESSION_CONFIGURATION_REQUEST,
    UPDATE_PROGRESSION_CONFIGURATION_SUCCESS,
    UPDATE_PROGRESSION_CONFIGURATION_FAILURE,

    DELETE_PROGRESSION_CONFIGURATION_REQUEST,
    DELETE_PROGRESSION_CONFIGURATION_SUCCESS,
    DELETE_PROGRESSION_CONFIGURATION_FAILURE,
} from "../actions/types";

const initialState = {
    configurations: [],
    loading: false,
    error: null,
    message: "",
    agentProgression: null,
    agentProgressionLoading: false,
    agentProgressionError: null,
};

const agentProgressionReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_AGENT_PROGRESSION_REQUEST:
    return {
        ...state,
        agentProgressionLoading: true,
        agentProgressionError: null,
    };

case FETCH_AGENT_PROGRESSION_SUCCESS:
    return {
        ...state,
        agentProgressionLoading: false,
        agentProgression: action.payload,
        agentProgressionError: null,
    };

case FETCH_AGENT_PROGRESSION_FAILURE:
    return {
        ...state,
        agentProgressionLoading: false,
        agentProgressionError: action.payload,
        agentProgression: null,
    };
        case FETCH_PROGRESSION_CONFIGURATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: Array.isArray(action.payload)
                    ? action.payload
                    : [],
                error: null,
                message:
                    "Progression configurations loaded successfully",
            };

        case FETCH_PROGRESSION_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                configurations: [],
                error: action.payload,
            };

        case CREATE_PROGRESSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case CREATE_PROGRESSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: [
                    ...state.configurations,
                    action.payload,
                ],
                message:
                    "Progression configuration created successfully",
            };

        case CREATE_PROGRESSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case UPDATE_PROGRESSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case UPDATE_PROGRESSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: state.configurations.map(
                    (configuration) =>
                        configuration.configuration_id ===
                        action.payload.configuration_id
                            ? {
                                  ...configuration,
                                  ...action.payload,
                              }
                            : configuration
                ),
                message:
                    "Progression configuration updated successfully",
            };

        case UPDATE_PROGRESSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case DELETE_PROGRESSION_CONFIGURATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case DELETE_PROGRESSION_CONFIGURATION_SUCCESS:
            return {
                ...state,
                loading: false,
                configurations: state.configurations.filter(
                    (configuration) =>
                        configuration.configuration_id !==
                        action.payload
                ),
                message:
                    "Progression configuration deleted successfully",
            };

        case DELETE_PROGRESSION_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default agentProgressionReducer;